import { appApiSlice } from 'src/api/app-ApiSlice';
import {
    TAG_FLOOR_ROOMS_AND_RELATED,
    TAG_GET_DEVICES,
    TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS,
} from 'src/api/api-tags';
import {
    ApiResponse,
    TectlyDocumentUploadResponse,
    TectlyFloorResultsResponse,
    TectlyFloorStatusResponse,
    TectlyMonthlyLimitResponse,
} from 'src/model/api/v2/data-contracts';

interface UploadFloorArgs {
    projectId: number;
    floorId: number;
    mockMode: boolean;
}

interface FloorArgs {
    tectlyFloorId: string;
    mockMode: boolean;
}

const mockQuery = (mockMode: boolean) => (mockMode ? '?mockMode=true' : '');

export const tectlyV2ApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        uploadTectlyFloor: builder.mutation<TectlyDocumentUploadResponse, UploadFloorArgs>({
            query: ({ projectId, floorId, mockMode }) => ({
                url: `v2/tectly/projects/${projectId}/upload-floor/${floorId}${mockQuery(mockMode)}`,
                method: 'POST',
            }),
        }),
        getTectlyFloorStatus: builder.query<TectlyFloorStatusResponse, FloorArgs>({
            query: ({ tectlyFloorId, mockMode }) =>
                `v2/tectly/floors/${tectlyFloorId}/get-status${mockQuery(mockMode)}`,
            keepUnusedDataFor: 0,
        }),
        getAndProcessTectlyResults: builder.mutation<TectlyFloorResultsResponse, FloorArgs>({
            query: ({ tectlyFloorId, mockMode }) => ({
                url: `v2/tectly/floors/${tectlyFloorId}/get-and-process-results${mockQuery(mockMode)}`,
                method: 'POST',
            }),
            invalidatesTags: [
                { type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS },
                { type: TAG_FLOOR_ROOMS_AND_RELATED },
                { type: TAG_GET_DEVICES },
            ],
        }),
        deleteTectlyFloor: builder.mutation<ApiResponse, number>({
            query: (uplanFloorId: number) => ({
                url: `v2/tectly/floors/${uplanFloorId}`,
                method: 'DELETE',
            }),
        }),
        getTectlyMonthlyLimit: builder.query<number, void>({
            query: () => `v2/tectly/get-monthly-limit`,
            transformResponse: (response: TectlyMonthlyLimitResponse) => response.monthlyLimit,
        }),
    }),
    overrideExisting: false,
});

export const {
    useUploadTectlyFloorMutation,
    useLazyGetTectlyFloorStatusQuery,
    useGetAndProcessTectlyResultsMutation,
    useDeleteTectlyFloorMutation,
    useGetTectlyMonthlyLimitQuery,
} = tectlyV2ApiSlice;
